var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 158,
    viewBox: "0 0 158 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.098 53.5239L130.431 36.6179V8.62081C130.429 6.46738 129.572 4.40329 128.05 2.88062C126.528 1.35919 124.464 0.502413 122.31 0.5H35.6897C33.5363 0.502417 31.4722 1.35919 29.9495 2.88062C28.4281 4.40326 27.5713 6.46735 27.5689 8.62081V36.6179L3.90172 53.5229C1.76884 55.048 0.502475 57.5084 0.5 60.1318V149.379C0.502417 151.533 1.35918 153.597 2.88061 155.119C4.40325 156.641 6.46732 157.498 8.62077 157.5H149.379C151.533 157.498 153.597 156.641 155.119 155.119C156.641 153.597 157.498 151.533 157.5 149.379V60.1318C157.499 57.5095 156.231 55.049 154.098 53.5242V53.5239ZM152.086 149.382L99.755 110.134L152.086 63.3925V149.382ZM5.914 149.381V63.3913L58.2452 110.133L5.914 149.381V149.381ZM79.0001 101.334L146.672 152.088H11.3247L79.0001 101.334ZM150.465 57.5815L130.43 75.4761V43.2686L150.465 57.5815ZM35.6898 5.91207H122.31C123.805 5.91328 125.016 7.12415 125.017 8.61898V80.3102L95.3392 106.817L80.6255 95.7819C79.6624 95.0605 78.3379 95.0605 77.3748 95.7819L62.661 106.817L32.9829 80.3102V8.61898C32.9841 7.12415 34.195 5.91328 35.6898 5.91207V5.91207ZM27.5691 75.4749L7.53319 57.579L27.5691 43.2674V75.4749Z",
    fill: "#505050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6181 21.0613L78.456 17L62.0791 26.3258L73.7613 32.4715L85.6181 21.0613Z",
    fill: "#019DF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.022 54.7546L49.0438 67.2822L63.6301 75.5551L63.0624 58.644L49.022 54.7546Z",
    fill: "#06BF97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.978 44.5264L91.4482 54.6473L96.405 73.8147L108 67.2178L107.978 44.5264Z",
    fill: "#FCD300"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8359 76.8014L78.5444 84L96.1004 73.9865L78.4134 64.7036L65.8359 76.8014Z",
    fill: "#8EEA36"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2539 29.0979L49 33.7823L49.0218 49.6835L60.7258 42.5065L57.2539 29.0979Z",
    fill: "#FF8A4A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.957 43.7527V33.7177L88.5664 22.7373L89.1123 38.5311L107.957 43.7527Z",
    fill: "#BEAAF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckInbox);
export default __webpack_public_path__ + "static/media/check-inbox.7af13c4640c49f00f6119983b9357e68.svg";
export { ForwardRef as ReactComponent };